<template>
<v-container class="roboto-text bg-color">
    <v-card-title class="roboto-text">
      Job positions
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="shrink roboto-text bg-color pa-3"
      ></v-text-field> -->
      <!-- text-field blue-grey -->
    </v-card-title>
    <v-spacer></v-spacer>
    <v-data-table
    dark
    class="ma-4 pa-1 roboto-text table-color"
      :headers="headers"
      :items="jobs"
      :search="search"
      :hide-default-footer="true"
    >
    <template v-slot:item.action="{ item }">
    <v-btn elevation=0 class="ma-2 white–-text roboto-text button-color" flat @click="openPage(item)">Apply</v-btn>
  </template>
    </v-data-table>
  </v-container>
</template>


<script>
export default {
  name: "JobPage",
  data () {
      return {
        search: '',
        headers: [
          {
            text: 'Job Title',
            align: 'start',
            value: 'title',
          },
          { text: 'Location', value: 'region' },
        //   { text: 'Job function', value: 'function' },
          { text: 'Seniority level', value: 'seniority' },
        //   { text: 'Employment type', value: 'employment' },
          { text: "", value: "action" }

        ],
        jobs: [
          {
            title: 'Manager, Digital Marketing',
            seniority: 'Mid-Senior level',
            region: 'Singapore',
            function: 'Marketing and Advertising',
            employment: 'Full-time',
            action: 'https://www.linkedin.com/jobs/view/manager-digital-marketing-at-one-esports-2528301574',
          },
          {
            title: 'Director, Marketing',
            seniority: 'Director',
            region: 'Singapore',
            function: 'Advertising, and Strategy/Planning',
            employment: 'Full-time',
            action: 'https://www.linkedin.com/jobs/view/director-marketing-at-one-esports-2515384795',
          },
          {
            title: 'WordPress Developer SDE 3',
            seniority: 'Associate',
            region: 'Bengaluru, Karnataka, India',
            function: 'Engineering and Information Technology',
            employment: 'Full-time',
            action: 'https://www.linkedin.com/jobs/view/wordpress-developer-sde-3-at-one-esports-2532201190',
          },
          {
            title: 'Performance Marketing Manager',
            seniority: 'Mid-Senior level',
            region: 'Singapore',
            function: 'Marketing and Advertising',
            employment: 'Full-time',
            action: 'https://www.linkedin.com/jobs/view/performance-marketing-manager-at-one-esports-2509130757',
          },

        ],
      }
    },
  methods: {
      openPage(item) {
          console.log(item)
          window.open(item.action)
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');

/* .bg-color .v-card__title {
    background: #021445;
} */ 

.roboto-text {
    font-family: 'Roboto', sans-serif;
    /* color: white; */
}
.searchlength {
    max-width: 200px;
}
table.cell-height{
  border-spacing: 0 2rem;
  color: white;
}
.theme--dark.v-btn.v-btn--has-bg.button-color {
    color:#021445;
    background-color: #ffc600;
}

/* .text-start {
    color: white;
} */
/* .v-sheet .theme--light.v-card .bg-color  {
    background-color:#021445;
}
.bg-color .theme--light.v-card{
    background: #021445;
} */
/* 
.v-data-table.roboto-text.table-color.v-data-table--has-bottom.theme--light {
    background: #090f20;
    color:white;
} */
</style>